﻿/*
 © Copyright 2024 webzaytsev.ru.
 * @author Nikita Zaytsev <nikita@webzaytsev.ru>
*/
import type { TProduct } from '@/types/TProduct';

type Response = {
    data: TProduct[];
    last_page: number;
};

export interface Params {
    page?: number;
    category_id?: number;
    search?: string;
    animal_id?: number;
    sub_category_id?: number;
    animal_size?: string;
    food_type_id?: number;
    animal_age?: string;
    on_main_page?: boolean;
    measurements?: string[];
    product_advantages?: string[];
}

const BASE_URL = `${import.meta.env.VITE_API_URL}/products`;

export async function getProducts(
    params: Params = {},
    signal: AbortSignal,
): Promise<Response | undefined> {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${import.meta.env.VITE_API_KEY}`);

    const searchParams = Object.values(params)
        ? `?${Object.entries(params)
              .map(([key, value]) => `${key}=${value}`)
              .join('&')}`
        : '';

    try {
        const response = await fetch(BASE_URL + searchParams, {
            headers: headers,
            signal: signal,
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        // Handle errors
        // @ts-ignore
        if (error.name === 'AbortError') {
            // @ts-ignore
            return 'abort';
        } else {
            console.error('Error fetching data:', error);
        }
    }
}
